/**
 * Файл с factory константами
 */
import { IAppServiceLanguages } from '@app/app.interface';
import { AppService } from '@app/app.service';
import { AppHelper } from '@app/core/app.helper';
import { AppSettings } from '@app/core/libraries/Settings/app-settings';
import { FuiTranslations } from '@fui/fui-components';
import { IMainLang } from '@interfaces/languages/main-lang';
import { InterfaceAccessMatrix } from '@modules/login/interfaces/login.interface';

/** Получение URL API сервера */
export const getServerUrl = (appServer: AppService): string => {
    return appServer.serverUrl;
};

/** Получение словаря с переводами */
export const getDictionary = (appServer: AppService): IMainLang => {
    return appServer?.language_dictionary;
};

/** Получение глобальных переводов для библиотеки FUI Components */
export const getFuiTranslations = (appService: AppService): FuiTranslations => {
    const lang = appService.language_dictionary;
    return {
        add: lang.system_add,
        choose: lang.system_choose,
        clear: lang.system_clear,
        close: lang.system_close,
        collapse: lang.system_collapse,
        expand: lang.system_expand,
        noData: lang.system_no_data,
        nothingFound: lang.rubricator_search_empty,
        selectAll: lang.system_select_all,
        selectNone: lang.system_select_none,
        monday: lang.cal_monday,
        tuesday: lang.cal_tuesday,
        wednesday: lang.cal_wednesday,
        thursday: lang.cal_thursday,
        friday: lang.cal_friday,
        saturday: lang.cal_saturday,
        sunday: lang.cal_sunday,
        monday_short: lang.cal_mo,
        tuesday_short: lang.cal_tu,
        wednesday_short: lang.cal_we,
        thursday_short: lang.cal_th,
        friday_short: lang.cal_fr,
        saturday_short: lang.cal_sa,
        sunday_short: lang.cal_su,
        january: lang.cal_january,
        february: lang.cal_february,
        march: lang.cal_march,
        april: lang.cal_april,
        may: lang.cal_mayl,
        june: lang.cal_june,
        july: lang.cal_july,
        august: lang.cal_august,
        september: lang.cal_september,
        october: lang.cal_october,
        november: lang.cal_november,
        december: lang.cal_december,
        january_short: lang.cal_jan,
        february_short: lang.cal_feb,
        march_short: lang.cal_mar,
        april_short: lang.cal_apr,
        may_short: lang.cal_may,
        june_short: lang.cal_jun,
        july_short: lang.cal_jul,
        august_short: lang.cal_aug,
        september_short: lang.cal_sep,
        october_short: lang.cal_oct,
        november_short: lang.cal_nov,
        december_short: lang.cal_dec,
    };
};

/** Получение объекта активных языков системы */
export const getAppLanguages = (appServer: AppService): { [key: string]: IAppServiceLanguages } => {
    return appServer?.languages;
};

/** Получение текущего глобального языка системы */
export const getCurrentLanguage = (appServer: AppService): IAppServiceLanguages => {
    return AppHelper.getCurrentLanguage(appServer);
};

/** Получение объекта с доступами */
export const getAccess = (appServer: AppService): InterfaceAccessMatrix => {
    return appServer?.accessMatrix;
};

/** Получение настроек системы */
export const getSettings = (appServer: AppService): AppSettings => {
    return appServer?.appSettings;
};

export const getCurrentLanguageAlias = (appServer: AppService): string => {
    return AppHelper.getCurrentLanguage(appServer).lang;
};
